import { lazyRenderWidgetByLoader, projectLoaders } from 'core-components/helpers/lazyLoad'
import { IWidgetSelector } from 'core-components/sitebuilder/models/IWidgetSelector'

projectLoaders['hpscm/'] = (name: string) => {
  const layoutName = name.split('/').at(-1)
  return import(`hpscm/components/layout/${layoutName}.tsx`)
}

export const WidgetSelector = (props: IWidgetSelector) => {
  const KbaseWidgetSelector = props.lazyWidgets?.KbaseWidgetSelector
  const PFWidgetSelector = props.lazyWidgets?.PFWidgetSelector
  const OrgchartWidgetSelector = props.lazyWidgets?.OrgchartWidgetSelector
  const DocflowWidgetSelector = props.lazyWidgets?.DocflowWidgetSelector

  const widgetLoaders: Record<string, () => Promise<any>> = {
    'spoc-home': () => import('hpscm/components/widgets/spoc/home/Home'),
    'manage-mcc-codes': () =>
      import('hpscm/components/widgets/organization/manageMCCCodes/ManageMCCCodes'),
    'connect-to-service-redirect': () =>
      import('hpscm/components/widgets/omnicom/serviceConnection/redirect'),
    'disconnect-service-redirect': () =>
      import('hpscm/components/widgets/omnicom/serviceConnection/redirect'),
    'connect-zoom-ac': () => import('hpscm/components/widgets/omnicom/serviceConnection/zoom/ac'),
    'nda-customers': () =>
      import('hpscm/components/widgets/omnicom/ndaCustomerList/NDACustomerList'),
    'access-request-status': () =>
      import('hpscm/components/widgets/campaignerMailer/accessRequestStatus/AccessRequestStatus'),
  }

  const widgetsWithMeta = ['spoc-home', 'nda-customers']

  if (props.viewModel in widgetLoaders) {
    return lazyRenderWidgetByLoader({
      id: props.viewModel,
      loader: widgetLoaders[props.viewModel],
      props: { ...props.props },
      loadMeta: widgetsWithMeta.includes(props.viewModel),
    })
  }

  return (
    (OrgchartWidgetSelector && OrgchartWidgetSelector(props)) ||
    (KbaseWidgetSelector && KbaseWidgetSelector(props)) ||
    (DocflowWidgetSelector && DocflowWidgetSelector(props)) ||
    (PFWidgetSelector && PFWidgetSelector(props)) ||
    null
  )
}
